import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../footer";
import NavBar from "../navbar/navbar";

function Layout() {
  return (
    <div>
      <NavBar />
      <div>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default Layout;
